/* eslint-disable camelcase */

import ApopheniaLogger from 'apophenia-javascript-logger';
import { v4 as uuid } from 'uuid';

const Logger = ApopheniaLogger.initialize({
  appId: 'elp.elp-fan-x-app',
  apiKey: window.APOPHENIA_API_KEY
});

const EVENT_FORMAT = '2.0';
const PROGRAM = 'real_estate';
const ACTION_NAME = 'interaction.complete.success';

export const INTERACTION_TYPES = Object.freeze({
  CLICKED: 'CLICKED',
  PAGE_VIEWED: 'PAGE_VIEWED',
  EDITED: 'EDITED',
  FOCUSED: 'FOCUSED',
  UNFOCUSED: 'UNFOCUSED',
  SELECTED: 'SELECTED',
  UNSELECTED: 'UNSELECTED'
});

export const EVENT_PRIORITY = Object.freeze({
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARN: 'WARN'
});

const REQUIRED_DATA_ATTRIBUTES = ['screen_id', 'interaction_type'];

export function send(data, callback = () => {}) {
  const date = new Date();
  const randomId = uuid();

  REQUIRED_DATA_ATTRIBUTES.forEach((attribute) => {
    if (!data[attribute]) {
      console.error(`Required data attribute missing: ${attribute}`); // eslint-disable-line no-console
    }
  });

  // See `apophenia_logging.md` for more information on this payload.
  Logger.send(
    ACTION_NAME,
    {
      instance: navigator.userAgent,
      epoch_ms: date.getTime(),
      event_fmt: EVENT_FORMAT,
      event_id: randomId,
      priority: EVENT_PRIORITY.INFO,
      time: date.toISOString(),
      cv: randomId.toString().concat('.0'),
      data: {
        referral_key: window.ELP_RFID,
        program_identifier: PROGRAM,
        ...data
      }
    },
    callback
  );
}
